export interface StaticQrCodeRequest {
  url: string;
  background_color?: string;
  code_name?: string;
  color?: string;
  cta_text_bottom?: string;
  cta_text_top?: string;
  data_pattern_shape?: string;
  download?: number;
  image_type?: string;
  logo_image_height?: number;
  logo_image_url?: string;
  logo_image_width?: number;
  studio_config_id?: string;
}

export interface StaticQrCodeResponse {
  url: string;
}
